module.exports = __webpack_public_path__ + "static/media/country_un.59754ae2.webp";